import {NetworkStatus} from 'apollo-client';

/**
 * Returns true if an Apollo network request is in ready or error state.
 *
 * "Not settled" state can be a useful alternative to the default "loading"
 * state if you also need to capture the brief window between the query being
 * initialized and the request actually being sent. For example, this could
 * help prevent flashing an empty/loaded state just before a request is made.
 */
export function isNetworkRequestSettled(
  networkStatus?: NetworkStatus
): boolean {
  return (
    networkStatus === NetworkStatus.ready ||
    networkStatus === NetworkStatus.error
  );
}
